import { z } from 'zod'

import { providerProperties } from './BaseModels'
import cachedDummies from './cachedDummies'
import parseModel from './parseModel'

export const providerParser = z.object({
  ...providerProperties,
})

export type Provider = z.infer<typeof providerParser>

export const dummyProvider = cachedDummies(
  (uuid: string, error?: any): Provider => ({
    isDummy: true,
    error,

    uuid,

    clientUuid: null,

    name: 'Dummy',

    avatar: null,
    address: null,
    phone: null,
    email: null,
    contactPerson: null,

    deletedAt: null,
    createdAt: new Date(),
    updatedAt: new Date(),
  })
)

export const parseProvider = parseModel(providerParser, dummyProvider)
